module.exports = __webpack_public_path__ + "static/img/14000148.11d44899.png";